import Api from "./Api"
import axios from "axios";



export const makeLogin = (credentials) =>{   
    return Api.post('/api/admin/login', credentials)
}

export const getEnquiryData =()=>{
    return Api.get('/api/get-all-enquiries')
}

export const postStudentEnquiry =(user)=>{
    return Api.post('/api/student-enquiries',user)
}

export const getAlumniSpeaks = () =>{
    return Api.get(`/api/getAll-alumni-speaks`)
  }

export const getPlacedStudents = () =>{
    return Api.get('/api/get-placed-students')
}

export const postStudentRegistration = (user) =>{
    return Api.post('/api/registration_students',user,{
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })
}

export const getFeesStructure = ()=>{
    return Api.get('/api/fees')
}

export const getAllPackages =()=>{
    return Api.get('/api/getAll-packages')
}

export const getGalleryImages =(type)=>{
    return Api.get(`/api/image-types?type=${type}`)
}

export const getRecognitionsAndApprovals =()=>{
    return Api.get('/api/getAll-recognition-and-approvals')
}

//MBABatch.jsx
export const getMBABatchList = async () => {
    const response = await Api.get("/api/mba_batches");
    return response.data; // ✅ Important: Axios puts the real data in `.data`
};

export const saveMBABatchList = async (data) => {
    return Api.post("/api/mba_batches", { students: data });
};  
  

//FeesDetailsTable.jsx
export const getFeesDetailsList = async () => {
    const feesResponse = await Api.get("/api/fees_details");
    return feesResponse.data;
};

export const saveFeesDetailsList = async (studentFees) => {
    return Api.post("/api/fees_details", studentFees); // ✅ send raw object
};

//DYPCollegeFeesTable.jsx
export const getDYPCollegeFeesDetailsList = async () => {
    const DYPFeesResponse = await Api.get(`/api/dypfees_details`);
    return DYPFeesResponse.data;
}
export const saveDYPCollegeFeesDetailsList = async (dypCollegeFees) => {
    return Api.post(`/api/dypfees_details`, dypCollegeFees); // ✅ send raw object
};


//NISM
export const getNISMDetailsList = async () => {
    const nismresponse = await Api.get(`/api/nism_certifications_details`);
    return nismresponse.data;
}
export const saveNISMDetailsList = async (nismCertifications) => {
    return Api.post(`/api/nism_certifications_details`, nismCertifications); // ✅ send raw object
};

//Finxl
export const getFINXLDetailsList = async () => {
    const finxlresponse = await Api.get(`/api/finxl_certifications_details`);
    return finxlresponse.data;
}
export const saveFINXLDetailsList = async (finxlCertifications) => {
    return Api.post(`/api/finxl_certifications_details`, finxlCertifications); // ✅ send raw object
};


//Presentation
export const getPresentationsDetailsList = async () => {
    const presentationresponse = await Api.get(`/api/presentations_details`);
    return presentationresponse.data;
}
export const savePresentationsDetailsList = async (presentationsdata) => {
    return Api.post(`/api/presentations_details`, presentationsdata); // ✅ send raw object
};


export const getAllBlogs = () =>{
    return Api.get(`/api/blogs`);
}